<!-- Zweck: Stellt die HTML-Struktur für shop dialogs nachliefern multi frage component im Frontend bereit. -->
<h1 mat-dialog-title>
  Nicht alle Produkte sind lieferbar!
</h1>
<div mat-dialog-content style="min-height: 100px">
  <table class="table table-striped table-hover">
    <thead>
      <tr>
        <td>Position</td>
        <td>Info</td>
        <td>Nachliefern?</td>
      </tr>
    </thead>
    <tbody>
      @for (m of messages; track m; let idx = $index) {
        <tr>
          <td>
            <strong [innerHTML]="m.title|raw"></strong>
          </td>
          <td style="vertical-align: top !important;">
            <div [innerHTML]="m.msg|raw"></div>
          </td>
          <td style="vertical-align: top !important; text-align: center">
            <mat-checkbox [(ngModel)]="nachliefernChecked[idx]" (change)="changeNachliefernChecked()"></mat-checkbox>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div mat-dialog-actions style="text-align: center">
  <button mat-flat-button (click)="doClose()">
    Laut Auswahl ({{nachliefernCheckedCounter}}) nachliefern
  </button>

  <button mat-stroked-button (click)="selectAll()">
    Alle ({{messages.length}}) nachliefern
  </button>

  <button mat-raised-button (click)="selectNone()">
    Nichts nachliefern
  </button>
</div>

